import "jquery";
import "owl.carousel";
import "./smoothScroll.js";
import "./scrollReveal.js";
import "./floatingShapes.js";
import "./horizontalScroll.js";
import "./meetClient.js";
import "./slide.js";
import "./workPage.js";
import "./projectDetail.js";
